import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { merge, $ } from "glamor";
import MUITextField from "material-ui/TextField";
import Cancel from "material-ui/svg-icons/navigation/cancel";
import classNames from "classnames";
import { theme } from "styles/theme";

interface IProps {
    fileName: string;
    onChangeFileName: (params: any) => void;
}

interface IState {
    focused: boolean;
}

export class RetailerSyncForm extends React.PureComponent<IProps, IState> {
    private styles = merge(
        $(" p", {
            fontSize: "13px",
            marginTop: "6px",
        }),
        $(" label", {
            fontSize: "12px",
            fontWeight: "400",
            color: theme.palette.darkGrey,
        }),
        $(" .inputWrapper", {
            display: "flex",
            alignItems: "center",
            border: `1px solid ${theme.palette.borderColor}`,
            borderRadius: "4px",
            padding: "0 16px",
        }),
        $(" .cancelIcon", {
            color: `${theme.palette.grey} !important`,
            cursor: "pointer",
        }),
        $(" .focused", {
            border: `1px solid ${theme.palette.blue}`,
        })
    );

    private muiStyles = {
        textField: {
            style: {
                width: "100%",
            },
            clearStyle: {
                top: "46px",
            },
            inputStyle: {
                paddingRight: "40px",
            },
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            focused: false,
        };
    }

    handleChangeFileName = (event: any, value: string) => {
        this.props.onChangeFileName(value);
    };

    handleClearValue = () => {
        this.props.onChangeFileName("");
    };

    handleFocus = () => {
        this.setState({ focused: true });
    };

    handleBlur = () => {
        this.setState({ focused: false });
    };

    render() {
        const { fileName } = this.props;
        return (
            <div {...this.styles}>
                <label>{formatMessage("File Name (optional)")}</label>
                <div className={classNames("inputWrapper", { focused: this.state.focused })}>
                    <MUITextField
                        name="filename"
                        value={fileName}
                        onChange={this.handleChangeFileName}
                        underlineShow={false}
                        style={this.muiStyles.textField.style}
                        inputStyle={this.muiStyles.textField.inputStyle}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                    <Cancel
                        onClick={this.handleClearValue}
                        className={classNames("cancelIcon", { hidden: !fileName })}
                    />
                </div>
                <p>
                    {formatMessage(
                        "*If no file name is entered, your file will be named with the title of the assortment."
                    )}
                </p>
            </div>
        );
    }
}
